import { types, actions } from './requests'
export const GETUSERLIST_TYPES = {
    ...types('GETUSERLIST'),
}
export const GETUSERLIST_ACTIONS = {
    ...actions('GETUSERLIST'),
}
